import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * PrivateRoute component to protect routes based on authentication and role.
 *
 * @param {Object} props
 * @param {JSX.Element} props.element - Component to render if authorized.
 * @param {string} [props.requiredRole] - Optional role required to access.
 * @param {string} [props.fallbackPath="/"] - Redirect path if unauthorized.
 * @returns {JSX.Element}
 */
const PrivateRoute = ({ element, requiredRole, fallbackPath = "/" }) => {
  const { session, loading } = useAuth();
  if (loading) return null;

  const token = session?.token;
  const storedRole = session?.role;
  const allowed = token && (!requiredRole || storedRole === requiredRole);

  return allowed ? element : <Navigate to={token ? fallbackPath : "/"} replace />;
};

export default PrivateRoute;
